import React, { createContext, useContext } from 'react';
import { ApiInterpreterRepository } from '../repositories/ApiInterpreterRepository';
import { useHttpClientCore } from '@/shared';
import SupplementAUseCase from '../../application/useCase/SupplementAUseCase';

interface ISupplementADIContext {
  supplementAUseCase: SupplementAUseCase;
}

export const SupplementADIContext = createContext<ISupplementADIContext | undefined>(undefined);

export const SupplementADIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const httpClient = useHttpClientCore();
  const interpreterRepository = new ApiInterpreterRepository(httpClient);
  const supplementAUseCase = new SupplementAUseCase(interpreterRepository);

  return (
    <SupplementADIContext.Provider value={{ supplementAUseCase }}>
      {children}
    </SupplementADIContext.Provider>
  );
};

export function useSupplementADIContext() {
  const ctx = useContext(SupplementADIContext);
  if (!ctx) throw new Error('useSupplementADIContext must be used within SupplementADIProvider');
  return ctx;
}
